import React from 'react';
import SongDetail from '../../components/SongDetail/songDetail';
import NavBar from '../../components/NavBarSearchSong';
import Settings from '../../assets/Settings.png';

const SongDetails = () => {
  return (
    <>
      <NavBar
        data="Song Details"
        icon={Settings}
        currentRouteName="Song Details"
        breadcrumbsPath={[{ name: 'Songs' }, { name: 'Search Songs', link: '/songs/search-songs' }]}
      />
      <div className="content" style={{ marginTop: 73 }}>
        <SongDetail />
      </div>
    </>
  );
};

export default SongDetails;

